module.exports = __webpack_public_path__ + "img/apple.ad7bdf77.svg";